import useClientList from "./useClientList";

const ClientCount = () => {
  const { isLoadingClients, resultCount } = useClientList();

  return (
    <div className="text-center">
      {isLoadingClients ? "Recherche en cours..." : <>{resultCount} résultats trouvés</>}
    </div>
  );
};

export default ClientCount;
